var $e9b4f57d23618517$exports = {};
$e9b4f57d23618517$exports = {
    "alert": `Opozorilo`,
    "dismiss": `Opusti`
};


export {$e9b4f57d23618517$exports as default};
//# sourceMappingURL=sl-SI.mjs.map
